module.exports = "/_next/static/images/pizza_kalin-c3632a088cbc4bd25a387f56c63ee69f.jpg";